module.exports = __webpack_public_path__ + "img/Arrow-simple90b.57660101.svg";